import { call, put, take, takeEvery, takeLatest } from "redux-saga/effects";
import { ADD_SELLITEM, ALL_SELLITEM_FROM_COLLECTION_ID, ALL_SELLITEM_NFT_COUNT, GET_ALL_SELLITEM, GET_ALL_SELLITEM_FAIL, GET_EXPLORE_LISTING, GET_PARTICULAR_SELLITEM, GET_RECENT_LISTING, LIKE_VIEW_SELLITEM, SELLITEM_FROM_COLLECTION_ID, SELL_ITEM_CURRENT_OWNER, TOP_SELL_ITEM, TRENDING_ARTWORK, UPDATE_PARTICULAR_SELLITEM, GET_CANVAS_PAPER_SIZE } from "./actionTypes";
import { addSellItemFail, addSellItemSuccess, allsellItemFromCollectionIdFail, allsellItemFromCollectionIdSuccess, allsellItemNFtCountFail, allsellItemNFtCountSuccess, getAllSellItemFail, getAllSellItemSuccess, getexploreListingFail, getexploreListingSuccess, getParticularSellItemFail, getParticularSellItemSuccess, getrecentListingFail, getrecentListingSuccess, likeViewSellItemFail, likeViewSellItemSuccess, sellItemFromCollectionIdFail, sellItemFromCollectionIdSuccess, sellItemsCurrentOwnerFail, sellItemsCurrentOwnerSuccess, topSellItemsFail, topSellItemsSuccess, trendingArtWorkFail, trendingArtWorkSuccess, updateSellItemFail, updateSellItemSuccess, getCanvasPaperSizeFail, getCanvasPaperSizeSuccess } from "./actions";
import { addSellItemApi, allSellItemCurrentOwnerApi, allSellItemFromCollectionIdApi, allSellItemNftCountApi, exploreListingApi, fetchSellItemApi, getAllOwnerApi, getAllSellItemApi, likeViewApi, recentListingApi, sellItemFromCollectionIdApi, topSellItemApi, trendingArtworkApi, updateOwnerApi, updateSellItemApi, getCanvasPaperSizeApi } from "helpers/backend_helper";
import moment from "moment"
function* fetchSellItem({ payload: { id, callback } }) {
  try {
    const response = yield call(fetchSellItemApi, id);

    if (response.status === "failure") {
      return yield put(getParticularSellItemFail(response.message));
    }

    callback && callback(response);
    yield put(getParticularSellItemSuccess(response));
  } catch (error) {
    yield put(getParticularSellItemFail(error));
  }
}
function* addSellItem({ payload: { data, callback } }) {
  try {
    const response = yield call(addSellItemApi, data);

    if (response.status === "failure") {
      return yield put(addSellItemFail(response.message));
    }

    callback && callback(response);
    yield put(addSellItemSuccess(response.data));
  } catch (error) {
    yield put(addSellItemFail(""));
  }
}

function* updateSellItem({ payload: { data, callback } }) {
  try {
    const response = yield call(updateSellItemApi, data);

    if (response.status === "failure") {
      return yield put(updateSellItemFail(response.message));
    }
    yield put(updateSellItemSuccess(response.data));
    callback && callback(response);
  } catch (error) {
    yield put(updateSellItemFail(""));
  }
}


function* getAllSellItem({ payload: { data, callback } }) {
  try {
    const response = yield call(getAllSellItemApi, data);
    if (response.status === "failure") {
      return yield put(getAllSellItemFail(response.message));
    }
    yield put(getAllSellItemSuccess(response.data));
    callback && callback(response);
   
  } catch (error) {
    yield put(getAllSellItemFail(error));
  }
}
function* sellItemFromCollectionId({ payload: { id, callback } }) {
  try {
    const response = yield call(sellItemFromCollectionIdApi, id);
    if (response.status === "failure") {
      return yield put(sellItemFromCollectionIdFail(response.message));
    }
    yield put(sellItemFromCollectionIdSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(sellItemFromCollectionIdFail(error));
  }
}

function* likeViewOwner({ payload: { data, callback } }) {
  try {
    const response = yield call(likeViewApi, data);
    if (response.status === "failure") {
      return yield put(likeViewSellItemFail(response.message));
    }

    callback && callback(response);
    yield put(likeViewSellItemSuccess(response.data));
  } catch (error) {
    console.log("error", error);
    yield put(likeViewSellItemFail(error));
  }
}

function* allSellItemFromCollectionId({ payload: { data, callback } }) {
  try {
    const response = yield call(allSellItemFromCollectionIdApi, data);
    if (response.status === "failure") {
      return yield put(allsellItemFromCollectionIdFail(response.message));
    }

    callback && callback(response);
    yield put(allsellItemFromCollectionIdSuccess(response));
  } catch (error) {
    console.log("error", error);
    yield put(allsellItemFromCollectionIdFail(error));
  }
}

function* allSellItemNftCount({ payload: { data, callback } }) {
  try {
    const response = yield call(allSellItemNftCountApi, data);
    if (response.status === "failure") {
      return yield put(allsellItemNFtCountFail(response.message));
    }
    yield put(allsellItemNFtCountSuccess(response.data[0].totalLikes))
    callback && callback(response);
  } catch (error) {
    yield put(allsellItemNFtCountFail(error));
  }
}

function* allSellItemCurrentOwner({ payload: { data, callback } }) {
  try {
    const response = yield call(allSellItemCurrentOwnerApi, data);
    if (response.status === "failure") {
      return yield put(sellItemsCurrentOwnerFail(response.message));
    }
    response.data.map((tr) => {
      let localtime = moment.unix(tr.created_date).local()
      tr.created_date = localtime.format('YYYY-MM-DD HH:mm:ss');
      if (tr.sold_date) {
        tr.sold_date = localtime.format('YYYY-MM-DD HH:mm:ss');
      }
      return tr;
    })
    yield put(sellItemsCurrentOwnerSuccess(response.data))
    callback && callback(response);
  } catch (error) {

    yield put(sellItemsCurrentOwnerFail(error));
  }
}
function* topSellItem({ payload: { data, callback } }) {
  try {
    const response = yield call(topSellItemApi, data);
    if (response.status === "failure") {
      return yield put(topSellItemsFail(response.message));
    }
    yield put(topSellItemsSuccess(response.data))
    callback && callback(response);
  } catch (error) {
    yield put(topSellItemsFail(error));
  }
}

function* trendingArtwork({ payload: { data, callback } }) {
  try {
    const response = yield call(trendingArtworkApi, data);
    if (response.status === "failure") {
      return yield put(trendingArtWorkFail(response.message));
    }
    yield put(trendingArtWorkSuccess(response.data))
    callback && callback(response);
  } catch (error) {
    yield put(trendingArtWorkFail(error));
  }
}

function* recentListing({ payload: { data, callback } }) {
  try {
    const response = yield call(recentListingApi, data);
    if (response.status === "failure") {
      return yield put(getrecentListingFail(response.message));
    }
    yield put(getrecentListingSuccess(response))
    callback && callback(response);
  } catch (error) {
    yield put(getrecentListingFail(error));
  }
}

function* exploreListing({ payload: { data, callback } }) {
  try {
    const response = yield call(exploreListingApi, data);
    if (response.status === "failure") {
      return yield put(getexploreListingFail(response.message));
    }
    yield put(getexploreListingSuccess(response))
    callback && callback(response);
  } catch (error) {
    yield put(getexploreListingFail(error));
  }
}

function* getCanvasPaperSize({ payload: { data, callback } }) {
  try {
    const response = yield call(getCanvasPaperSizeApi, data);
    if (response.status === "failure") {
      return yield put(getCanvasPaperSizeFail(response.message));
    }
    yield put(getCanvasPaperSizeSuccess(response))
    callback && callback(response);
  } catch (error) {
    yield put(getCanvasPaperSizeFail(error));
  }
}

function* SellItemsSaga() {
  yield takeEvery(GET_PARTICULAR_SELLITEM, fetchSellItem);
  yield takeEvery(ADD_SELLITEM, addSellItem);
  yield takeLatest(UPDATE_PARTICULAR_SELLITEM, updateSellItem);
  yield takeEvery(GET_ALL_SELLITEM, getAllSellItem);
  yield takeEvery(SELLITEM_FROM_COLLECTION_ID, sellItemFromCollectionId);
  yield takeEvery(LIKE_VIEW_SELLITEM, likeViewOwner);
  yield takeEvery(ALL_SELLITEM_FROM_COLLECTION_ID, allSellItemFromCollectionId);
  yield takeEvery(ALL_SELLITEM_NFT_COUNT, allSellItemNftCount);
  yield takeEvery(SELL_ITEM_CURRENT_OWNER, allSellItemCurrentOwner);
  yield takeEvery(TOP_SELL_ITEM, topSellItem);
  yield takeEvery(TRENDING_ARTWORK, trendingArtwork);
  yield takeEvery(GET_RECENT_LISTING, recentListing);
  yield takeEvery(GET_EXPLORE_LISTING, exploreListing);
  yield takeEvery(GET_CANVAS_PAPER_SIZE, getCanvasPaperSize);
}

export default SellItemsSaga;